import { DifficultyAdjustment } from './DifficultyDirector';

export function buildNeutralDifficultyAdjustment(
  segmentId: DifficultyAdjustment['segmentId'],
  segmentIndex: number,
  armyRatio: number
): DifficultyAdjustment {
  return {
    segmentId,
    segmentIndex,
    armyRatio,
    ddaDelta: 0,
    spawnIntervalMultiplier: 1,
    eliteRatioMultiplier: 1,
    gatePositivityDelta: 0,
    weaponBoxChanceDelta: 0,
  };
}
